import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng9RutModule } from 'ng9-rut';
import { MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedViewsModule } from '../shared/shared-views.module';

import { RecepcionPedidosComponent } from './recepcion-pedidos/recepcion-pedidos.component';
import { RecepcionPedidosModalVerPedidoComponent } from './recepcion-pedidos/modal-ver-pedido/modal-ver-pedido.component';
import { RecepcionPedidosModalResultComponent } from './recepcion-pedidos/modal-result/modal-result.component';
import { AnalisisDemandaComponent } from './analisis-demanda/analisis-demanda.component';
import { AnalisisDemandaModalDetalleMovimientosComponent } from './analisis-demanda/modal-detalle-movimientos/modal-detalle-movimientos.component';
import { AnalisisDemandaModalCambioProductoComponent } from './analisis-demanda/modal-cambio-producto/modal-cambio-producto.component';
import { AnalisisDemandaModalPedidosComponent } from './analisis-demanda/modal-pedidos/modal-pedidos.component';
import { ConfirmarNotaVentaComponent } from "./confirmar-nota-venta/confirmar-nota-venta.component";
import { ConfirmarNotaVentaModalVerPedidoComponent } from "./confirmar-nota-venta/modal-ver-pedido/modal-ver-pedido.component";
import { ConfirmarNotaVentaModalResultadoComponent } from './confirmar-nota-venta/modal-resultado/modal-resultado.component';
import { ConfirmarNotaVentaModalVerAdvertenciaComponent } from './confirmar-nota-venta/modal-ver-advertencia/modal-ver-advertencia.component';
import { ImprimirFacturaComponent } from './imprimir-factura/imprimir-factura.component';
import { ImprimirFacturaDetalleComponent } from './imprimir-factura/modal-detalle/modal-imprimir-factura-detalle.component';
import { ImprimirFacturaResultadoComponent } from './imprimir-factura/modal-resultado/modal-imprimir-factura-resultado.component';
import { VentasModule } from "../ventas/ventas.module";
import { EditarNotaVentaComponent } from './analisis-demanda/editar-nota-venta/editar-nota-venta.component';
import { CabeceraNotaVentaComponent } from './analisis-demanda/editar-nota-venta/cabecera-nota-venta/cabecera-nota-venta.component';
import { DetalleNotaVentaComponent } from './analisis-demanda/editar-nota-venta/detalle-nota-venta/detalle-nota-venta.component';

@NgModule({
  declarations: [
    RecepcionPedidosComponent,
    RecepcionPedidosModalVerPedidoComponent,
    RecepcionPedidosModalResultComponent,
    AnalisisDemandaComponent,
    AnalisisDemandaModalDetalleMovimientosComponent,
    AnalisisDemandaModalCambioProductoComponent,
    AnalisisDemandaModalPedidosComponent,
    ConfirmarNotaVentaComponent,
    ConfirmarNotaVentaModalVerPedidoComponent,
    ConfirmarNotaVentaModalResultadoComponent,
    ConfirmarNotaVentaModalVerAdvertenciaComponent,
    ImprimirFacturaComponent,
    ImprimirFacturaDetalleComponent,
    ImprimirFacturaResultadoComponent,
    EditarNotaVentaComponent,
    CabeceraNotaVentaComponent,
    DetalleNotaVentaComponent,
  ],
  imports: [
    CommonModule,
    ToastModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    Ng9RutModule,
    FormsModule,
    ReactiveFormsModule,
    SharedViewsModule,
    SharedModule
  ],
  exports: [
    RecepcionPedidosComponent,
    AnalisisDemandaComponent,
    ConfirmarNotaVentaComponent
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class FacturacionMasivaModule { }
